import { Screen } from '~/screens/Admins/[id]/edit';

export const AdminEdit: React.FC = () => <Screen />;
